import { DateTime } from "luxon";
import type { SingleDateRangeValue } from "../DateRangeInput";

interface GetEndMinimumParams {
  tempStart: SingleDateRangeValue;
  endInputPropMin?: DateTime;
}

function getEndMinimum({
  tempStart,
  endInputPropMin
}: GetEndMinimumParams): DateTime | undefined {
  const endMinCandidates = [tempStart, endInputPropMin].filter(
    (d): d is DateTime => d !== undefined && d !== null
  );
  return DateTime.max(...endMinCandidates);
}

export { getEndMinimum };
